import { css } from '@emotion/css';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as MyDesignImage } from '../../assets/images/my-design/img_image_mydesign.svg';
import { StartQrScanButton } from './StartQrScanButton';

const tryMyDesignStyles = css`
  max-width: 480px;
  color: #938666;
  text-align: center;
  margin: 0 auto;
  padding: 0 24px;
  h2 {
    color: #4d3906;
    font-size: 16px;
    margin: 16px 0;
  }
  .image {
    width: 80%;
    max-width: 240px;
    margin: 0 auto;
  }
  .desc {
    font-size: 14px;
    line-height: 1.6;
    margin: 0 0 24px;
  }
  .spacer {
    height: 10px;
  }
  .buttons button {
    margin: 0 0 16px;
  }
`;

export const TryMyDesign = () => {
  const { t } = useTranslation('my_design');
  return (
    <section className={tryMyDesignStyles}>
      <h2>{t('top_heading')}</h2>
      <div className="image">
        <MyDesignImage />
      </div>
      <p className="desc">{t('top_desc_02')}</p>
      <div className="buttons">
        <StartQrScanButton source="camera" />
        <StartQrScanButton source="photoLibrary" />
      </div>
    </section>
  );
};
